<template>
    <div class="topbar-container">
        <zbList
            v-model="store"
            :minLen="6"
            :isKeep="true"
            class="container shop-list"
            itemCls="shop-list-item list-item-inline"
            v-slot:default="{ item }"
        >
            <div class="item shadow-bg" v-on:click="onInfoClick(item)">
                <div
                    class="img bg-100"
                    :style="{backgroundImage: 'url(' + item.smallImage + ')'}"
                    v-on:click.stop="onInfoClick(item)"
                ></div>
                <div class="content">
                    <div class="fz_30 overflow">{{item.name}}</div>
                    <div class="bh bc ico-container">
                        <i class="bg-contain ico-maintenance"></i>
                        <span class="b1 overflow c_red fz_34">{{item.price}}</span>
                    </div>
                </div>
            </div>
        </zbList>
    </div>
</template>
<script>
import store from "@/utils/store";
import { drivingList } from "@/api/car";
import zbList from "@/components/data/List";
export default {
    name: "CarDrivingList",
    components: { zbList },
    data() {
        return {
            store: {
                data: [],
                isVanLoading: false,
                isError: false,
                isFinished: true,
                proxy: {
                    getList: drivingList
                }
            }
        };
    },
    created: function() {
        store.load(this.store);
    },
    methods: {
        onInfoClick: function(item) {
            this.$router.push({
                name: "CarDrivingInfo",
                params: { id: item.id, smallImage: item.smallImage }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.shop-list {
    background-color: #f7f8f8;
    padding: 0 20px;
}
</style>